<template>
  <b-modal id="ssh-keys-modal"
    v-model="visible"
    title="SSH Keys"
    centered
    size="xl"
    @show="reset"
    @hidden="reset"
    @ok="handleOK">
    <b-form-textarea id="ssh-keys-input"
      v-model="authorizedKeys"
      size="lg"
      placeholder="Paste SSH public keys here..."
      rows="10" />
  </b-modal>
</template>

<script>
export default {
  name: 'UserSshKeysModal',

  props: {
    activeUser: {
      type: Object,
      required: true,
      default: () => {
        return {}
      },
    },
  },

  emits: ['update-ssh-keys'],

  data() {
    return {
      visible: false,
      authorizedKeys: '',
    }
  },

  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    reset() {
      this.authorizedKeys = this.activeUser.authorized_keys || ''
    },
    handleOK(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.$emit('update-ssh-keys', { authorizedKeys: this.authorizedKeys })
      this.$nextTick(() => {
        this.visible = false
      })
    },
  },
}
</script>
